class StateComparison extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.tableBody = this.querySelector('tbody');
    this.rows = Array.from(this.querySelectorAll('[data-state-row]'));
    this.search = this.querySelector('[data-state-search]');
    this.status = this.querySelector('[data-state-status]');
    this.sortButtons = Array.from(this.querySelectorAll('[data-state-sort]'));
    this.collator = new Intl.Collator(document.documentElement.lang || 'en', {
      numeric: true,
      sensitivity: 'base',
    });

    this.search?.addEventListener('input', () => this.filterRows());
    this.sortButtons.forEach((button) => {
      button.addEventListener('click', () => this.sortRows(button));
    });
    this.updateStatus();
  }

  filterRows() {
    const query = (this.search?.value || '').trim().toLocaleLowerCase();
    this.rows.forEach((row) => {
      row.hidden = Boolean(query) && !row.dataset.stateName.includes(query);
    });
    this.updateStatus();
    this.keepSearchVisible();
  }

  keepSearchVisible() {
    if (document.activeElement !== this.search) return;
    cancelAnimationFrame(this.visibilityFrame);
    this.visibilityFrame = requestAnimationFrame(() => {
      if (document.activeElement !== this.search) return;
      const panel = document.querySelector('[data-sc-fbt]');
      if (!panel || getComputedStyle(panel).position !== 'fixed') return;
      const panelRect = panel.getBoundingClientRect();
      const fieldRect = this.search.getBoundingClientRect();
      if (!panelRect.height || fieldRect.bottom <= panelRect.top - 16) return;
      let scroller = this.search.parentElement;
      while (scroller && !(scroller.scrollHeight > scroller.clientHeight + 1 && /auto|scroll/.test(getComputedStyle(scroller).overflowY))) {
        scroller = scroller.parentElement;
      }
      (scroller || window).scrollBy({top: fieldRect.bottom - panelRect.top + 16, behavior: 'instant'});
    });
  }

  sortRows(button) {
    const key = button.dataset.stateSort;
    const type = button.dataset.sortType || 'text';
    const previousDirection = button.dataset.sortDirection;
    const direction = previousDirection === 'ascending' ? 'descending' : 'ascending';
    const multiplier = direction === 'ascending' ? 1 : -1;

    this.sortButtons.forEach((item) => {
      delete item.dataset.sortDirection;
      item.closest('th')?.setAttribute('aria-sort', 'none');
    });
    button.dataset.sortDirection = direction;
    button.closest('th')?.setAttribute('aria-sort', direction);

    this.rows.sort((leftRow, rightRow) => {
      const left = leftRow.querySelector(`[data-sort-key="${key}"]`)?.dataset.sortValue || '';
      const right = rightRow.querySelector(`[data-sort-key="${key}"]`)?.dataset.sortValue || '';
      if (type === 'number') {
        return (Number(left) - Number(right)) * multiplier;
      }
      return this.collator.compare(left, right) * multiplier;
    });
    this.rows.forEach((row) => this.tableBody.append(row));
  }

  updateStatus() {
    if (!this.status) return;
    const visible = this.rows.filter((row) => !row.hidden).length;
    this.status.textContent = `Showing ${visible} of ${this.rows.length} states.`;
  }
}

if (!customElements.get('state-comparison')) {
  customElements.define('state-comparison', StateComparison);
}
